import React from 'react'
// import { CSSTransition } from 'react-transition-group'

const msgs = [
  'Join our whatsapp group to get more updates.',
  'Send Name, City to 88 55 99 86 00',
  'आमच्या प्रॉडक्ट्स बद्दल अधिक माहितीसाठी आमचा व्हॅट्सऍप ग्रुप जॉईन करा',
  'आपले नाव, गाव ८८ ५५ ९९ ८६ 00 नंबर ला  पाठवा',
  'टीप : हा ग्रुप फक्त महिलांसाठी आहे.'
]
class Notice extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      hideMsg: false,
      msg: ''
    }
    this.counter = 0;
    this.tick = this.tick.bind(this)
  }
  componentDidMount() {
    this.tick();
    this.timer = setInterval(this.tick, 3000);
  }
  componentWillUnmount() {
    clearInterval(this.timer)
  }
  tick() {
    // this.setState({ hideMsg: true })
    if (this.counter > 4) {
      this.counter = 0;
    }
    this.setState({ msg: msgs[this.counter] })
    this.counter++;
  }
  render() {
    return (
      <div className="notice-holder">
        <a href="tel:8855998600" className="anim-notice">
          {this.state.msg}
        </a>
        </div>
    )
  }
}
export default Notice;


// WEBPACK FOOTER //
// ./src/Notice.jsx